import {
  CHANGE_LANGUAGE,
  ACTIVITY_GROUP_DETAILS_SUCCESS,
  JOB_FAMILIES_DETAILS_SUCCESS,
  LOCATIONS_DETAILS_SUCCESS,
  PUNCH_ENTRY_LOADING,
  COUNTRY_DETAILS_SUCCESS,
  MANAGER_EMAIL_LOOKUP_SUCCESS,
  MANAGER_COST_CENTER_DATA_SUCCESS,
  SELECTED_WORKER_ON_REVIEW,
  SELECTED_WEEK_ON_REVIEW,
  SELECTED_MANAGER_ON_REVIEW,
  SELECTED_TEAM_ON_REVIEW,
  SELECTED_MONTH_ON_REPORT,
  EXCEPTIONS_DETAILS_SUCCESS,
  DSC_LOAD_LOCATIONS_DATA,
  DSC_DRAWER_STATE,
  PROJECT_DETAILS_BYCOUNTRY,
  PROJECTS_DETAILS_SUCCESS,
  MANAGE_WORKERS_FILTERS_LIST,
  REPORT_VIEW_FILTERS_LIST,
  ALL_PUNCH_VIEW_FILTERS_LIST,
  MANAGE_ACTIVITY_GROUP_FILTERS_LIST,
  SAVE_DEVICE_LOCATION,
  SET_DASHBOARD_DISTRICTS,
  SET_DASHBOARD_BUILDINGS,
  SET_DASHBOARD_MANAGER,
  TRANSPORT_DETAILS_FILTERS_LIST,
  SET_DASHBOARD_APH_DISTRICT,
  WORKDAY_CONFIG_SUCCESS
} from "../CONSTANTS";
import {
  getActivityGroupDetails,
  getJobFamilyDetails,
  getLocationDetails,
  getCountryDetails,
  getManagerEmailDetails,
  getExceptionDetails,
  getProjectsByCountry,
  getProjectDetails,
} from "../../services";

import {
  getWorkdayConfigDetails
} from "../../services/rconfig";

import { getLocationDevDetails } from "services/dsc";

/**
 * fn to change app language.
 * @param {string} language code.
 * @return: {Object} action object
 */
const setlanguageAction = (payload) => ({
  type: CHANGE_LANGUAGE,
  payload,
});

/**
 * fn to set a new language for rendering.
 * @param {string}
 * @return: void
 */
export const setLanguage = (payload) => (dispatch) => {
  console.log("appActions > setLanguage...", payload);

  dispatch(setlanguageAction(payload));
};

const getActivityGroupSuccess = (payload) => ({
  type: ACTIVITY_GROUP_DETAILS_SUCCESS,
  payload,
});

const getJobFamiliesSuccess = (payload) => ({
  type: JOB_FAMILIES_DETAILS_SUCCESS,
  payload,
});

const getExceptionsSuccess = (payload) => ({
  type: EXCEPTIONS_DETAILS_SUCCESS,
  payload,
});

const getLocationsSuccess = (payload) => ({
  type: LOCATIONS_DETAILS_SUCCESS,
  payload,
});
const getProjectsSuccess = (payload) => ({
  type: PROJECTS_DETAILS_SUCCESS,
  payload,
});

export const getCountriesSuccess = (payload) => ({
  type: COUNTRY_DETAILS_SUCCESS,
  payload,
});

const getManagerEmailsSuccess = (payload) => ({
  type: MANAGER_EMAIL_LOOKUP_SUCCESS,
  payload,
});

const getManagerCostCenterSuccess = (payload) => ({
  type: MANAGER_COST_CENTER_DATA_SUCCESS,
  payload,
})

const getWorkdayConfigSuccess = (payload) => ({
  type: WORKDAY_CONFIG_SUCCESS,
  payload,
});

export const getDropDownData = () => (dispatch) => {
  console.log("appActions > getDropDownData...");
  dispatch(getPunchLoading());
  dispatch(getActivityGroups());
  dispatch(getJobFamilies());
  //dispatch(getLocations());
};

/**
 * fn for fetching activity group details.
 * @param {string}
 * @return: {Object} containing activity group details
 */
export const getActivityGroups = () => (dispatch) => {
  console.log("in appActions: getActivityGroups...");
  getActivityGroupDetails().then((data) => {
    if (data) {
      const activityGroups = data;
      dispatch(getActivityGroupSuccess(activityGroups));
    }
  });
};

/**
 * fn for fetching job family details with ID.
 * @param {string}
 * @return: {Object} containing job family details
 */
export const getJobFamilies = () => (dispatch) => {
  console.log("in appActions: getJobFamilies...");
  getJobFamilyDetails().then((data) => {
    if (data) {
      const jobFamilies = data;
      dispatch(getJobFamiliesSuccess(jobFamilies));
    }
  });
};

/**
 * fn for fetching exception details with ID.
 * @param {string}
 * @return: {Object} containing exception details
 */
export const getExceptions = () => (dispatch) => {
  console.log("in appActions: getExceptions...");
  getExceptionDetails().then((data) => {
    if (data) {
      const exceptions = data;
      dispatch(getExceptionsSuccess(exceptions));
    }
  });
};

/**
 * fn for fetching location details.
 * @param {string}
 * @return: {Object} containing location details
 */
export const getLocations = (country, alternateCountry) => (dispatch) => {
  console.log("in appActions: getLocation...");
  getLocationDetails(country, alternateCountry).then((data) => {
    if (data) {
      const locations = data;
      console.log("data in gld", data);
      dispatch(getLocationsSuccess(locations));
    }
  });
};
/**
 * fn for fetching Project details.
 * @param {string}
 * @return: {Object} containing Project details
 */
export const getProjects = (country) => (dispatch) => {
  console.log("in appActions: getProjects...");
  getProjectDetails(country).then((data) => {
    if (data) {
      const projects = data;
      //console.log("in appActions: getProjects...",locations);
      dispatch(getProjectsSuccess(projects));
    }
  });
};

export const getPunchLoading = () => ({
  type: PUNCH_ENTRY_LOADING,
});

/**
 * fn for fetching country details.
 * @param {string}
 * @return: {Object} containing activity group details
 */
export const getCountries = () => (dispatch) => {
  console.log("in appActions: getCountries...");
  getCountryDetails().then((data) => {
    if (data) {
      const countries = data;
      dispatch(getCountriesSuccess(countries));
    }
  });
};

/**
 * fn for fetching manager email details.
 * @param {string}
 * @return: {Object} containing activity group details
 */
export const getManagerEmails = (country) => (dispatch) => {
  console.log("in appActions: getManagerEmails...", country);
  getManagerEmailDetails(country).then((data) => {
    if (data) {
      const {managers:managerEmails, managersCostCenterData} = data;
      dispatch(getManagerEmailsSuccess(managerEmails));
      dispatch(getManagerCostCenterSuccess(managersCostCenterData));
    }
  });
};

/**
 * fn for fetching workday config details.
 * @return: {Object} containing activity group details
 */
export const getWOrkdayConfig = () => (dispatch) => {
  console.log("in appActions: getManagerEmails...");
  getWorkdayConfigDetails().then((data) => {
    if (data) {
      const workdayConfig = data;
      dispatch(getWorkdayConfigSuccess(workdayConfig));
    }
  });
};

/**
 * fn for fetching locationDev building details.
 * @param {string}
 * @return: {Object} containing building details for each district.
 */
export const getLocationsDSC = (country) => (dispatch) => {
  console.log("in appActions: getLocationsDSC...");
  getLocationDevDetails(country).then((data) => {
    if (data) {
      dispatch(loadLocationsDSC(data));
    }
  });
};

/**
 * fn for setting dsc drawer state.
 * @param {boolean}
 * @return: null
 */
export const setDrawerOpen = (drawerOpen) => (dispatch) => {
  console.log("in appActions: setDrawerOpen...");
  dispatch(setDSCDrawerOpen(drawerOpen));
};

/**
 * fn for storing  filter data  in redux.
 * @param {object}
 * @return: null
 */
export const saveFilterList = (filterList) => (dispatch) => {
  console.log("in appActions: saveManageWorkersFilterList...");
  dispatch(saveManageWorkersFilterList(filterList));
};

/**
 * fn for storing  filter data  in redux.
 * @param {object}
 * @return: null
 */
export const saveReportViewFilterList = (filterList) => (dispatch) => {
  console.log("in appActions: saveReportViewFilterList...");
  dispatch(saveReportViewFilterData(filterList));
};

/**
 * fn for storing  filter data  in redux.
 * @param {object}
 * @return: null
 */
export const saveTransportDetailsFilterList = (filterList) => (dispatch) => {
  console.log("in appActions: saveTransportDetailsFilterList...");
  dispatch(saveTransportDetailsFilterData(filterList));
};

/**
 * fn for storing  filter data  in redux.
 * @param {object}
 * @return: null
 */
export const saveAllPunchViewFilterList = (filterList) => (dispatch) => {
  console.log("in appActions: saveAllPunchViewFilterList...");
  dispatch(saveAllPunchViewFilterData(filterList));
};

/**
 * fn for storing  filter data  in redux.
 * @param {object}
 * @return: null
 */
export const saveManageActivityGroupFilterList = (filterList) => (dispatch) => {
  console.log("in appActions: saveManageActivityGroupFilterList...");
  dispatch(saveManageActivityGroupFilterData(filterList));
};

/**
 * fn for storing dashboard  districs data  in redux.
 * @param {list}
 * @return: null
 */
export const saveDashboardDistricts = (districts) => (dispatch) => {
  console.log("in appActions: saveDashboardDistricts...");
  dispatch(saveDashboardDistrictsData(districts));
};

/**
 * fn for storing dashboard Aph distric  data  in redux.
 * @param {list}
 * @return: null
 */
export const saveDashboardDistrictForAph = (district) => (dispatch) => {
  console.log("in appActions: saveDashboardDistrictForAph...");
  dispatch(saveDashboardDistrictForAphData(district));
};

/**
 * fn for storing  buildings data  in redux.
 * @param {list}
 * @return: null
 */
export const saveDashboardBuildings = (buildings) => (dispatch) => {
  console.log("in appActions: saveDashboardBuildings...");
  dispatch(saveDashboardBuildingsData(buildings));
};

export const selectedWorkerOnReview = (payload) => ({
  type: SELECTED_WORKER_ON_REVIEW,
  payload,
});

export const selectedWeekOnReview = (payload) => ({
  type: SELECTED_WEEK_ON_REVIEW,
  payload,
});

export const selectedMonthOnReport = (payload) => ({
  type: SELECTED_MONTH_ON_REPORT,
  payload,
});

export const selectedManagerForApproval = (payload) => ({
  type: SELECTED_MANAGER_ON_REVIEW,
  payload,
});

export const selectedTeamOnReview = (payload) => ({
  type: SELECTED_TEAM_ON_REVIEW,
  payload,
});

export const loadLocationsDSC = (payload) => ({
  type: DSC_LOAD_LOCATIONS_DATA,
  payload,
});
export const setDSCDrawerOpen = (payload) => ({
  type: DSC_DRAWER_STATE,
  payload,
});

// export const getProjectDetails = (country) => (dispatch) => {
//   console.log("in appActions: getLocationsDSC...");
//   getProjectsByCountry(country).then((data) => {
//     if (data) {
//       dispatch(getProjectDetailsByCountry(data));
//     }
//   });
// };

export const getProjectDetailsByCountry = (payload) => ({
  type: PROJECT_DETAILS_BYCOUNTRY,
  payload,
});
export const saveManageWorkersFilterList = (payload) => ({
  type: MANAGE_WORKERS_FILTERS_LIST,
  payload,
});
export const saveReportViewFilterData = (payload) => ({
  type: REPORT_VIEW_FILTERS_LIST,
  payload,
});

export const saveTransportDetailsFilterData = (payload) => ({
  type: TRANSPORT_DETAILS_FILTERS_LIST,
  payload,
});

export const saveAllPunchViewFilterData = (payload) => ({
  type: ALL_PUNCH_VIEW_FILTERS_LIST,
  payload,
});
export const saveManageActivityGroupFilterData = (payload) => ({
  type: MANAGE_ACTIVITY_GROUP_FILTERS_LIST,
  payload,
});

export const saveDashboardDistrictsData = (payload) => ({
  type: SET_DASHBOARD_DISTRICTS,
  payload,
});

export const saveDashboardDistrictForAphData = (payload) => ({
  type: SET_DASHBOARD_APH_DISTRICT,
  payload,
});

export const saveDashboardBuildingsData = (payload) => ({
  type: SET_DASHBOARD_BUILDINGS,
  payload,
});

export const saveDashboardManagerData = (payload) =>({
  type: SET_DASHBOARD_MANAGER,
  payload
})
// Location specific actions

export const saveDeviceCountryCode = (payload) => ({
  type: SAVE_DEVICE_LOCATION,
  payload,
});
